import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../../contexts/AuthContext";
import Alert from "../Alert";
import { svg } from "../../resources/Svg";

const signinVariants = {
  hidden: {
    scale: 0,
    opacity: 0.1,
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.3, delay: 0.2 },
  },
  exit: {
    scale: 0,
    transition: { ease: "easeInOut" },
  },
};

const ForgotPassword = ({ containerMinHeight }) => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [infoMsg, setInfoMsg] = useState("");
  const { resetPassword, currentUser } = useAuth();

  useEffect(() => {
    if (currentUser !== null) history.push("/Dashboard");
  }, [currentUser, history]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return setErrorMsg("Please type the email");

    try {
      setErrorMsg("");
      setLoading(true);
      await resetPassword(email);
      setInfoMsg(`Check Your email "${email}" for further instructions`);
      setEmail("");
    } catch (error) {
      setInfoMsg("");
      setErrorMsg(error.message);
    }
  };

  return (
    <>
      <motion.main
        style={{ minHeight: `calc(100vh - ${containerMinHeight}px)` }}
        className="flex items-center justify-center pb-16 pt-10 px-4 sm:px-6 lg:px-8"
        variants={signinVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="mt-6 text-center text-3xl uppercase tracking-tight font-extrabold text-gray-800">
              Reset your password
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600 ">
              Remembered the password?
              <Link
                to="/SignIn"
                className="font-medium text-indigo-600 hover:text-indigo-500 ml-1 capitalize"
              >
                sign in Now
              </Link>
            </p>
          </div>

          <div className="bg-gray-50 border p-5 rounded-2xl shadow-lg">
            <form className="my-5 space-y-12">
              <div className="space-y-8">
                {/*Email Section*/}
                <section className="flex flex-col mb-4">
                  <label
                    htmlFor="email"
                    className="mb-6 font-medium text-gray-800"
                  >
                    Email Address
                  </label>
                  <input
                    autoComplete="email"
                    className=" shadow-sm py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                    type="email"
                    value={email}
                    name="email"
                    required
                    placeholder="Enter Email Here"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {console.log(email)}
                </section>
              </div>

              {/*End forget password*/}

              {/*Button Sign in*/}
              <button
                disabled={loading}
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={handleSubmit}
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                Reset Password
              </button>
              {/*End Button Sign in*/}
            </form>
            {errorMsg && (
              <Alert
                svg={svg.danger}
                iconFlag={"red-500"}
                textFlag={"red-600"}
                text={errorMsg}
              />
            )}
            {infoMsg && (
              <Alert
                svg={svg.info}
                iconFlag={"blue-600"}
                textFlag={"blue-700"}
                text={infoMsg}
                bgColor={"blue-100"}
              />
            )}
          </div>
        </div>
      </motion.main>
    </>
  );
};

export default ForgotPassword;
